<script>
  import FileInput from '~componentes/InputFile.vue'
  import { checkbox } from 'vue-strap';
  import 'vue-strap/dist/vue-strap-lang';

  export default {
    components: { FileInput, checkbox },
    props: {
      arquivos: {
        type: Array,
        required: true,
      },
      inscricao: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        deletados: [],
        arquivosInterno: new Array(1),
      }
    },
    methods: {
      deletar(arquivo) {
        this.arquivos.splice(this.arquivos.indexOf(arquivo), 1);
        this.deletados.push(this.nomeArquivo(arquivo));
      },
      download(arquivo) {
        this.$emit('download', this.nomeArquivo(arquivo));
      },
      nomeArquivo(arquivo) {
        return arquivo.slice(arquivo.lastIndexOf('\\') + 1);
      },
      adicionarArquivo() {
        this.arquivosInterno.push(null);
      },
      limparArquivos() {
        this.deletados = [];

        while (this.arquivosInterno.length != 0) {
          this.arquivosInterno.pop();
        }

        for (var i = 0; i < 1; i++) {
          this.adicionarArquivo();
          this.$refs.fileInput[i].removerArquivo();
        }
      },
      existeArquivo() {
        let existeArquivo = false;
        for (let arquivo of this.arquivosInterno) {
          if (arquivo) {
            existeArquivo = true;
            break;
          }
        }
        return existeArquivo;
      },
      emitChanges() {

        let a = []
        for (let arquivo of this.arquivosInterno) {
          if (arquivo) {
            a.push(arquivo.name)
          }
        }
        this.$emit('input', a);
      },
    },
    computed: {},
    mounted() {
    },
    created() {
    }
  }
</script>

<template>
  <div>
    <div>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Arquivos enviados</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="arquivo in arquivos">
            <td>{{ nomeArquivo(arquivo) }}</td>
            <td class="action">
              <button type="button" class="btn btn-xs btn-success" @click="download(arquivo)">
                <i class="fa fa-download"></i>
              </button>
            </td>
          </tr>
          <tr v-if="arquivos.length === 0">
            <td colspan="2">Nenhum arquivo encontrado.</td>
          </tr>
        </tbody>
      </table>

      <div class="hr-line-dashed margin-top-20"></div>

      <div class="row">
        <div class="form-group col-xs-2">
          <div class="checkbox" style="padding-top: 12px">
            <checkbox v-model="inscricao.arquivosAprovados" value="1" type="primary">
              Arquivos aprovados
            </checkbox>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <label class="control-label" for="observacaoArquivosAprovados">
              Observa&ccedil;&otilde;es dos arquivos
            </label>

            <textarea class="form-control"
                      id="observacaoArquivosAprovados"
                      v-model="inscricao.observacaoArquivosAprovados">
          </textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-matricular/componentes/compartilhado/FormArquivos.vue